import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            游戏分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            探索多元游戏世界
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            超过800款精品游戏，涵盖六大热门品类，找到最适合您的游戏体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category, index) => (
            <Link
              key={category.id}
              to={`/category?tab=${category.id}`}
              className="group p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <span className="text-xs text-foreground-400 font-medium px-2 py-1 rounded-md bg-background-100 whitespace-nowrap">
                  {category.gameCount}款游戏
                </span>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {category.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {category.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-sm text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                查看详情
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-medium whitespace-nowrap bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors duration-200 cursor-pointer"
          >
            查看全部游戏分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}